import { Reveal } from "./Reveal";

export const SectionHeading = ({ bab, label, title, sub, dark = false, testid }) => (
  <div className="max-w-3xl">
    <Reveal>
      <div className="flex items-center gap-3 mb-5">
        <span
          data-testid={`${testid}-bab`}
          className={`font-mono text-xs uppercase tracking-[0.25em] px-3 py-1.5 rounded-full border whitespace-nowrap shrink-0 ${
            dark ? "border-nightline text-amber2 bg-nightcard" : "border-line text-terra bg-badge"
          }`}
        >
          {bab}
        </span>
        <span className={`font-mono text-xs uppercase tracking-[0.25em] ${dark ? "text-soft" : "text-soft"}`}>
          {label}
        </span>
      </div>
    </Reveal>
    <Reveal delay={0.1}>
      <h2
        data-testid={`${testid}-title`}
        className={`font-serif tracking-tight leading-[1.12] text-3xl sm:text-4xl lg:text-5xl ${
          dark ? "text-[#F4EFE6]" : "text-ink"
        }`}
      >
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.2}>
        <p className={`mt-5 text-base md:text-lg leading-relaxed ${dark ? "text-[#B9C6BC]" : "text-soft"}`}>
          {sub}
        </p>
      </Reveal>
    )}
  </div>
);
